<template>
  <div class="training-detail-work-list-component">
    <div class="work-list">
      <div class="work-list-item"
           v-for="(item, index) in workList"
           :key="index"
      >
        <div class="year-block"
             v-if="!item.hideYear"
        >
          {{ item.createdTime|formatTime('yyyy') }}年
        </div>
        <div class="info-block">
          <div class="date-block">
            <span class="day">{{ item.createdTime|formatTime('dd') }}</span>
            <span class="month">{{ item.createdTime|formatTime('MM') }}月</span>
          </div>
          <div class="audio-block">
            <div class="audio-item"
                 v-for="(audioItem, audioIndex) in item.data"
                 :key="audioIndex"
            >
              <div @click="handleWorkDetail(audioItem.id)">
                <div class="player-component">
                  <audio-player v-if="audioItem"
                                :current="audioItem.id"
                                :source="audioItem.source"
                                :duration="audioItem.duration"
                                type="work"
                  />
                </div>
                <div class="title-item">{{ audioItem.levelTitle }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import AudioPlayer from '@/components/TrainingPlayer/AudioPlayer';
  import { getJsDateObject, formatYear } from '@/utils/index';

  export default {
    name: 'TrainingDetailWorkList',
    components: {
      AudioPlayer,
    },
    data() {
      return {
        workList: [],
      };
    },
    props: {
      works: {
        type: Array,
        required: true,
      },
    },
    methods: {
      compare(property) {
        return (obj1, obj2) => {
          const value1 = obj1[property];
          const value2 = obj2[property];
          return value2 - value1;
        };
      },
      fetchWorkList() {
        const works = formatYear(this.works.sort(this.compare('createdTime')), 'createdTime');
        works.map((item) => {
          const date = getJsDateObject(item.createdTime);
          const day = date.getDate();
          item.day = day;
          return item;
        });
        const map = {};
        const temp = [];
        for (let i = 0; i < works.length; i++) {
          const ai = works[i];
          if (!map[ai.day]) {
            temp.push({
              levelId: ai.id,
              day: ai.day,
              hideYear: ai.hideYear,
              createdTime: ai.createdTime,
              data: [ai],
            });
            map[ai.day] = ai;
          } else {
            for (let j = 0; j < temp.length; j++) {
              const dj = temp[j];
              if (dj.day === ai.day) {
                dj.data.push(ai);
                break;
              }
            }
          }
        }

        this.workList = temp;
      },
      handleWorkDetail(id) {
        const route = { name: 'TrainingWorkDetail', params: { id } };
        this.$router.push(route);
      },
    },
    created() {
      this.fetchWorkList();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .training-detail-work-list-component {
    background: @color-white;
  }

  .work-list {
    padding: @size-base;
  }

  .work-list-item {
    margin-top: @size-large;
    &:first-child {
      margin-top: @size-base;
    }
  }

  .year-block {
    font-size: @font-size-extra-large;
    color: @color-text-base;
    margin-bottom: @size-base;
    margin-top: @size-base;
  }

  .info-block {
    display: flex;
    justify-content: space-between;
  }

  .date-block {
    color: @color-text-base;
    .day {
      font-size: @font-size-extra-extra-large;
      font-weight: @font-weight-primary;
      margin-right: @size-small;
    }
    .month {
      font-size: 26px;
    }
  }

  .audio-item {
    width: 480px;
    height: 174px;
    padding: @size-small @size-base;
    background: @background-color-base;
    border-radius: @border-radius-base * 4;
    margin-bottom: @size-base;
    display: flex;
    flex-direction: column;
    justify-content: center;
    &:last-child {
      margin-bottom: 0;
    }
  }

  .title-item {
    margin-top: @size-extra-small;
    align-self: flex-start;
    font-size: @font-size-base;
    color: @color-text-base;
  }

  .player-component {
    display: inline-flex;
    background: @color-white;
    border-radius: 34px;
  }
</style>
